import { SidebarLeft } from "components/ui/SidebarLeft/SidebarLeft"
import { ConfigurationTabs } from "./layout/ConfigurationTabs/ConfigurationTabs"
import { Outlet } from "react-router-dom"
import style from "./PageConfiguration.module.scss"

const { pageConfiguration, content } = style

export const PageConfiguration = () => {
	return (
		<section className={pageConfiguration}>
			<SidebarLeft>
				<ConfigurationTabs />
			</SidebarLeft>
			<div className={content}>
				<Outlet />
			</div>
		</section>
	)
}
